import { axios, Response } from '../index'
import { Therapist } from './get-therapist-by-id'

export type UpdateTherapistDTO = Omit<
  Therapist,
  'id' | 'avatar' | 'accessProfiles'
> & { accessProfileIds: string[] }

const updateTherapistById = (
  therapistId: string,
  body: UpdateTherapistDTO
): Response<Therapist> => {
  return axios.put(`/v1/therapists/${therapistId}`, body)
}

export default updateTherapistById
